import cn from 'classnames/bind';
import React from 'react';
import styles from './styles.styl';
import { Button } from '@consta/uikit/Button';
import { useMediaQuery } from 'react-responsive';
import { Text } from '@consta/uikit/Text';
import { IconClose } from '@consta/uikit/IconClose';
import { IconBackward } from '@consta/uikit/IconBackward';
import { IInputsArrayType } from 'src/utils/type';

const cx = cn.bind(styles);

export interface IResultsCalculationModelProps {
  className?: string;
  setIsResultModal: React.Dispatch<React.SetStateAction<boolean>>;
  setIsRunningModal: React.Dispatch<React.SetStateAction<boolean>>;
  outputsValue: IInputsArrayType[];
  nameModal: string;
}

const ResultsCalculationModel: React.FC<IResultsCalculationModelProps> = ({
  className,
  setIsResultModal,
  setIsRunningModal,
  nameModal,
  outputsValue,
}) => {
  const isMobile = useMediaQuery({ maxWidth: 460 });

  const vh = window.innerHeight * 0.01;

  document.documentElement.style.setProperty('--vh', `${vh}px`);

  return (
    <div className={cx('ResultsCalculationModel', className)}>
      <div className={cx('ResultsCalculationModel__title')}>
        {isMobile && (
          <Button
            className={cx('ResultsCalculationModel__buttonCloseMobile')}
            iconSize="s"
            view="clear"
            onlyIcon
            iconLeft={IconBackward}
            onClick={() => {
              setIsRunningModal(false);
              setIsResultModal(false);
            }}
          />
        )}
        <Text className={cx('ResultsCalculationModel__data')} weight="semibold">
          {`Результаты расчета ${nameModal}`}
        </Text>
        {!isMobile && (
          <Button
            className={cx('ResultsCalculationModel__buttonClose')}
            iconSize="s"
            view="clear"
            onlyIcon
            iconLeft={IconClose}
            onClick={() => {
              setIsRunningModal(false);
              setIsResultModal(false);
            }}
          />
        )}
      </div>
      <div className={cx('ResultsCalculationModel__content')}>
        <div className={cx('ResultsCalculationModel__output')}>
          {outputsValue.map((item, index) => (
            <div key={index}>
              <Text
                className={cx('ResultsCalculationModel__name')}
                display="inlineBlock"
                view="secondary"
                size="s"
              >
                {`${item.name}:`}
              </Text>
              <Text size="s" display="inlineBlock">
                {item.value}
              </Text>
            </div>
          ))}
        </div>
      </div>
      <div className={cx('ResultsCalculationModel__save')}>
        <Button
          onClick={() => {
            setIsResultModal(false);
          }}
          size="s"
          label={'Назад'}
          view="ghost"
          className={cx(
            'ResultsCalculationModel__buttonSave',
            'ResultsCalculationModel__back',
          )}
        />
        <Button
          onClick={() => {
            setIsResultModal(false);
            setIsRunningModal(false);
          }}
          size="s"
          label={'Закрыть'}
          className={cx('ResultsCalculationModel__buttonSave')}
        />
      </div>
    </div>
  );
};

export default ResultsCalculationModel;
